/**
 * DAS "PROBLEM"
 *
 * In den Prüfberichten zur Vereinfachten Überwachung der BITV 2.0 von 2023 und 2024 wurde bemängelt, dass der Fokus
 * bei Änderung der Eingrenzung oder Sortierung der Suchergebnisse durch das Laden einer neuen Seite wieder an den
 * Seitenanfang springt (WCAG SC 2.4.3 Focus Order).
 *
 * Nach unserer Auslegung des WCAG Kriteriums sollte das hier nicht anzuwenden sein, weil wir zu einer neuen URL navigieren;
 * die BFIT Bund Prüfstelle interpretiert das aber anders und sieht die anders eingegrenzte oder sortierte Suchergebnisseite
 * als die gleiche Seite wie vorher an.
 *
 * UNSERE LÖSUNG
 *
 * Um der Prüfstelle entgegen zu kommen, vergleichen wir beim Laden der Seite die URL und die Referrer URL um zu
 * untersuchen, ob Eingrenzung oder Sortierung sich geändert haben. Ist das der Fall, nehmen wir an, dass ein:e
 * Nutzer:in die Veränderung veranlasst hat und setzen den Fokus auf das verändert-aktive Element.
 */
(function () {
    const sucheVerfeinernLinks = document.querySelectorAll('[data-suche-param]');
    const OBSERVED_URL_PARAMS = [...new Set(Array.from(sucheVerfeinernLinks).map(el => el.getAttribute('data-suche-param')))];

    const currentUrl = new URL(window.location.href);
    const currentHash = currentUrl.hash.slice(1); // slice entfernt das '#'
    const isExpectedUrl = OBSERVED_URL_PARAMS.includes(currentHash);
    const referrerUrl = new URL(document.referrer);
    const isExpectedReferrer = referrerUrl.origin === currentUrl.origin;

    if (!isExpectedUrl || !isExpectedReferrer) return;

    const aktiverLink = Array.from(sucheVerfeinernLinks).filter((link) => {
        return link.dataset.sucheParam === currentHash && link.getAttribute('aria-current') === 'true';
    })[0];

    if (aktiverLink && isUserFocusable(aktiverLink)) {
        window.addEventListener('load', function() {
            aktiverLink.focus();
        });
    }

    function isUserFocusable(element) {
        if (!(element instanceof HTMLElement)) {
            return false;
        }

        const focusableTags = ['INPUT', 'SELECT', 'TEXTAREA', 'BUTTON', 'A', 'AREA'];
        const isDisabled = element.disabled;
        const isHidden = element.offsetParent === null;
        const hasHref = element.hasAttribute('href');
        const tabIndex = element.getAttribute('tabindex');

        return (
            (!isDisabled && !isHidden) &&
            (focusableTags.includes(element.tagName) ||
                (element.tagName === 'A' && hasHref) ||
                (tabIndex !== null && tabIndex !== '-1'))
        );
    }
})();
